/** @format */

import React from 'react';
import { Menu } from 'antd';
import styles from './globalHeader.module.scss';
import { IS_PRODUCTION } from 'src/constants';

export const menuAppDropDown = lang => {
  const shopBaseUrl = 'https://vdo-shop.com';
  const headerLinks = {
    myVDOPortal: IS_PRODUCTION ? 'https://my.vdo.com/' : 'https://staging.my.vdo.com',
    vdoFleet: 'https://www.my-fis.com/fleetservices/',
    fleetsWebsite: {
      en: 'https://www.fleet.vdo.com/',
      fr: 'https://www.fleet.vdo.fr/',
      de: 'https://www.fleet.vdo.de/',
      es: 'https://www.fleet.vdo.es',
      it: 'https://www.fleet.vdo.it/',
      nl: 'https://www.vdo-fleet.nl/',
      'nl-BE': 'https://www.vdo-fleet.nl/',
      pl: 'https://www.fleet.vdo.pl',
      'de-AT': 'https://www.fleet.vdo.at/',
      'en-IE': 'https://www.vdo-fleet.co.uk/',
      'en-GB': 'https://www.vdo-fleet.co.uk',
      bg: 'https://www.fleet.vdo.com/',
      cs: 'https://www.fleet.vdo.com/cs-cz/',
      sk: 'https://www.fleet.vdo.com/sk-sk/',
      hu: 'https://www.fleet.vdo.com/hu-hu/',
      sr: 'https://www.fleet.vdo.com/sr-rs/',
      hr: 'https://www.fleet.vdo.com/hr-hr/',
      bs: 'https://www.fleet.vdo.com/',
      da: 'https://www.fleet.vdo.com/da-dk/',
      ro: 'https://www.fleet.vdo.com/ro-ro/',
      et: 'https://www.fleet.vdo.com/et-ee/',
      fi: 'https://www.fleet.vdo.com/fi-fi/',
      el: 'https://www.fleet.vdo.com/el-gr/',
      is: 'https://www.fleet.vdo.com/',
      lv: 'https://www.fleet.vdo.com/lv-lv/',
      lt: 'https://www.fleet.vdo.com/lt-lt/',
      no: 'https://www.fleet.vdo.com/nb-no/',
      pt: 'https://www.fleet.vdo.com/pt-pt/',
      'pt-BR': 'https://www.fleet.vdo.com.br/',
      sl: 'https://www.fleet.vdo.com/sl-sl/',
      sv: 'https://www.vdo.se/',
      tr: 'https://www.fleet.vdo.com/tr-tr/',
      'de-CH': 'https://www.fleet.vdo.de/'
    },
    vdoShop: {
      en: `${shopBaseUrl}/en/`,
      fr: `${shopBaseUrl}/fr/`,
      de: `${shopBaseUrl}/de/`,
      es: `${shopBaseUrl}/es/`,
      it: `${shopBaseUrl}/it/`,
      nl: `${shopBaseUrl}/nl/`,
      'nl-BE': `${shopBaseUrl}/nl/`,
      pl: `${shopBaseUrl}/pl/`,
      'de-AT': `${shopBaseUrl}/at/`,
      'en-IE': `${shopBaseUrl}/gb/`,
      'en-GB': `${shopBaseUrl}/gb/`,
      bg: `${shopBaseUrl}/en/`,
      cs: `${shopBaseUrl}/en/`,
      sk: `${shopBaseUrl}/en/`,
      hu: `${shopBaseUrl}/en/`,
      sr: `${shopBaseUrl}/en/`,
      hr: `${shopBaseUrl}/en/`,
      bs: `${shopBaseUrl}/en/`,
      da: `${shopBaseUrl}/en/`,
      ro: `${shopBaseUrl}/en/`,
      et: `${shopBaseUrl}/en/`,
      fi: `${shopBaseUrl}/en/`,
      el: `${shopBaseUrl}/en/`,
      is: `${shopBaseUrl}/en/`,
      lv: `${shopBaseUrl}/en/`,
      lt: `${shopBaseUrl}/en/`,
      no: `${shopBaseUrl}/en/`,
      pt: `${shopBaseUrl}/en/`,
      'pt-BR': `${shopBaseUrl}/en/`,
      sl: `${shopBaseUrl}/en/`,
      sv: `${shopBaseUrl}/en/`,
      tr: `${shopBaseUrl}/en/`,
      'de-CH': `${shopBaseUrl}/de/`
    },
    learningManagementSystem: 'https://continental.litmoseu.com/account/login/?',
    extranet: IS_PRODUCTION ? 'https://extranet.vdo.com/' : 'https://staging.extranet.vdo.com/'
  };

  return [
    {
      key: '4',
      label: (
        <a href={headerLinks.vdoShop[lang] || headerLinks.vdoShop.en} target="_blank" rel="noopener noreferrer">
          Shops
        </a>
      )
    },
    {
      key: '3',
      label: (
        <a
          href={headerLinks.fleetsWebsite[lang] || headerLinks.fleetsWebsite.en}
          target="_blank"
          rel="noopener noreferrer"
        >
          Fleet Sites
        </a>
      )
    },
    {
      key: '5',
      label: (
        <a href={headerLinks.learningManagementSystem} target="_blank" rel="noopener noreferrer">
          LMS
        </a>
      )
    },
    {
      key: '6',
      label: (
        <a href={headerLinks.extranet} target="_blank" rel="noopener noreferrer">
          Extranet
        </a>
      )
    }
  ];
};

export const AppsDropdown = props => {
  return (
    <Menu className={styles.menuDropDown}>
      <Menu.Item key="0">
        <a href="https://my.vdo.com/" target="_blank" rel="noopener noreferrer">
          myVDO Portal
        </a>
      </Menu.Item>

      <Menu.Item key="1">
        <a href="https://www.fleet.vdo.com/support/#VDO+Fleet+Login" target="_blank" rel="noopener noreferrer">
          TIS-Web
        </a>
      </Menu.Item>

      <Menu.Item key="2">
        <a href="https://www.fleet.vdo.com/" target="_blank" rel="noopener noreferrer">
          Fleets website
        </a>
      </Menu.Item>

      <Menu.Item key="3">
        <a href="https://vdo-shop.com/" target="_blank" rel="noopener noreferrer">
          VDO Shop
        </a>
      </Menu.Item>

      <Menu.Item key="4">
        <a href="https://www.vdo-academy.com/" target="_blank" rel="noopener noreferrer">
          VDO Academy
        </a>
      </Menu.Item>

      <Menu.Item key="5">
        <a href="https://extranet.my.vdo.com/" target="_blank" rel="noopener noreferrer">
          Extranet
        </a>
      </Menu.Item>
    </Menu>
  );
};
